<template>
    <div v-if="componentLoader" class="position-relative h-100">
        <app-overlay-loader />
    </div>
    <div v-else>
        <app-overlay-loader v-if="preloader" />
        <form class="mb-0" v-else ref="form" :data-url="`escorters/${escorter.selectedEscorter.id}`"
            :class="{'loading-opacity': preloader}">
            <div class="row">
                <div class="col-md-6">
                    <!-- First Name Input -->
                    <div class="form-group">
                        <label for="first_name">{{ $t('first_name') }}
                            <span style="color: crimson">*</span>
                        </label>
                        <app-input id="first_name" type="text" v-model="escorter.selectedEscorter.first_name"
                            :placeholder="$t('first_name')" :required="true" />
                    </div>
                </div>
                <div class="col-md-6">
                    <!-- Last Name Input -->
                    <div class="form-group">
                        <label for="last_name">{{ $t('last_name') }}
                            <span style="color: crimson">*</span>
                        </label>
                        <app-input id="last_name" type="text" v-model="escorter.selectedEscorter.last_name"
                            :placeholder="$t('last_name')" :required="true" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <!-- Middle Name Input -->
                    <div class="form-group">
                        <label for="middle_name">{{ $t('middle_name') }}</label>
                        <app-input id="middle_name" type="text" v-model="escorter.selectedEscorter.middle_name"
                            :placeholder="$t('middle_name') " />
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="user_date_of_birth">{{ $t('date_of_birth') }} <span
                            style="color: crimson">*</span></label>
                    <app-input id="user_date_of_birth" type="date" v-model="escorter.selectedEscorter.date_of_birth"
                        :required="true" />
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ $t('gender') }}</label>
                        <app-input type="radio" :list="genderList" v-model="escorter.selectedEscorter.gender" />
                    </div>
                </div>
                <div class="col-md-6">
                    <!-- City Input -->
                    <div class="form-group">
                        <label for="city">{{ $t('city_work') }} <span style="color: crimson">*</span></label>
                        <app-input class="w-100" id="city" v-model="escorter.selectedEscorter.city" :list="cityList"
                            :placeholder="$t('city')" type="select" :required="true" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <!-- Matricule Input -->
                    <div class="form-group">
                        <label for="matricule">{{ $t('matricule') }} <span style="color: crimson">*</span></label>
                        <app-input id="matricule" type="text" v-model="escorter.selectedEscorter.matricule"
                            :placeholder="$t('matricule')" :required="true" />
                    </div>
                </div>
                <div class="col-md-6">
                    <!-- Address Input -->
                    <div class="form-group">
                        <label for="address">{{ $t('address') }} <span style="color: crimson">*</span></label>
                        <app-input id="address" type="text" v-model="escorter.selectedEscorter.address"
                            :placeholder="$t('address') " :required="true" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <!-- Driver Phone Number Input -->
                    <div class="form-group">
                        <label for="phone">
                            {{ $t('personal_phone') }} <span style="color: crimson">*</span>
                        </label>
                        <app-input id="phone" type="tel-input" v-model="escorter.selectedEscorter.phone"
                            :required="true" />
                    </div>
                </div>
                <div class="col-md-6">
                    <!-- Work Phone Input -->
                    <div class="form-group">
                        <label for="work_phone">{{ $t('work_phone') }}</label>
                        <app-input id="work_phone" type="tel-input" v-model="escorter.selectedEscorter.work_phone"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <!-- Driver IMEI Number Input -->
                    <div class="form-group">
                        <label for="imei_one">
                            {{ $t('phone_imei_one') }}
                        </label>
                        <app-input id="imei_one" type="text" v-model="escorter.selectedEscorter.imei_one"
                            :placeholder="$t('IMEI 1')" />
                    </div>
                </div>
                <div class="col-md-6">
                    <!-- Work IMEI 2 Input -->
                    <div class="form-group">
                        <label for="imei_two">{{ $t('phone_imei_two') }}</label>
                        <app-input id="imei_two" type="text" v-model="escorter.selectedEscorter.imei_two"
                            :placeholder="$t('IMEI 2')" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <!-- Category Input -->
                    <div class="form-group">
                        <label for="category">{{ $t('employee_category') }} <span
                                style="color: crimson">*</span></label>
                        <app-input class="w-100" id="category" v-model="escorter.selectedEscorter.category"
                            :list="categoryList" :placeholder="$t('category')" type="select" :required="true" />
                    </div>
                </div>
                <div class="col-md-6">
                    <!-- Bank Account Input -->
                    <div class="form-group">
                        <label for="bank_account">{{ $t('bank_account') }} </label>
                        <app-input id="bank_account" type="text" v-model="escorter.selectedEscorter.bank_account"
                            :placeholder="$t('bank_account')" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <!-- Contact Person Input -->
                    <div class="form-group">
                        <label for="contact_person">{{ $t('contact_person') }}</label>
                        <app-input id="contact_person" type="tel-input"
                            v-model="escorter.selectedEscorter.contact" />
                    </div>
                </div>
                <div class="col-md-6">
                    <!-- Marital Status Input -->
                    <div class="form-group">
                        <label for="marital_status">{{ $t('marital_tatus') }} <span
                                style="color: crimson">*</span></label>
                        <app-input class="w-100" id="marital_status" v-model="escorter.selectedEscorter.marital_status"
                            :list="maritalStatusList" :placeholder="$t('marital_status')" type="select"
                            :required="true" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <!-- Status Input -->
                    <div class="form-group">
                        <label for="status">{{ $t('status') }} </label>
                        <app-input class="w-100" id="status" v-model="escorter.selectedEscorter.active"
                            :list="statusList" :placeholder="$t('status')" type="select" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <!-- Comment & Observations Input -->
                    <div class="form-group">
                        <label for="comment">{{ $t('comment_observation') }}</label>
                        <app-input id="comment" type="textarea" v-model="escorter.selectedEscorter.comment"
                            :placeholder="$t('comment_observation')" :textAreaRows="5" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 action-buttons">
                    <button type="button" class="btn btn-primary mr-2 mt-4" @click.prevent="submit">
                        {{ $t('save') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import GlobalHelperMixin from "../../../Mixins/global/GlobalHelperMixin";
    import {FormMixin} from "../../../../core/mixins/form/FormMixin";
    import * as actions from "../../../Config/ApiUrl";
    import AppLibrary from "../../../Helpers/AppLibrary";
    import {urlGenerator} from "../../../Helpers/AxiosHelper";
    import { mapState } from "vuex";

    export default {
        name: "EscorterPersonalInfo",
        extends: AppLibrary,
        mixins: [FormMixin, GlobalHelperMixin],
        computed: {
            ...mapState({
                escorter: state => state.escorter
            }),
        },
        data() {
            return {
                preloader: false,
                componentLoader: false,
                statusList: [
                    { id: '', value: this.$t('choose_one') },
                    { id: 1, value: this.$t('active') },
                    { id: 0, value: this.$t('inactive') },
                ],
                cityList: [
                    { id: '', value: this.$t('choose_one') },
                    { id: 'kolwezi', value: 'Kolwezi' },
                    { id: 'likasi', value: 'Likasi' },
                    { id: 'lubumbashi', value: 'Lubumbashi' },
                    { id: 'kasumbalesa', value: 'Kasumbalesa' },
                    { id: 'mokambo', value: 'Mokambo' },
                    { id: 'sakania', value: 'Sakania' },
                    { id: 'ndola', value: 'Ndola' },
                ],
                categoryList: [
                    { id: '', value: this.$t('choose_one') },
                    { id: 'team_leader', value: this.$t('team_leader') },
                    { id: 'commander', value: this.$t('commander') },
                    { id: 'supervisor', value: this.$t('supervisor') },
                    { id: 'checkpoint', value: this.$t('checkpoint') },
                    { id: 'transporter', value: this.$t('transporter') },
                    { id: 'loader', value: this.$t('loader') },
                    { id: 'guard', value: this.$t('guard') },
                    { id: 'control', value: this.$t('control') },
                ],
                maritalStatusList: [
                    { id: '', value: this.$t('choose_one') },
                    { id: 'single', value: this.$t('single') },
                    { id: 'married', value: this.$t('married') },
                    { id: 'divorced', value: this.$t('divorced') },
                ],
                genderList: [
                    {
                        id: 'male',
                        value: this.$t('male')
                    },
                    {
                        id: 'female',
                        value: this.$t('female')
                    }
                ],
            }
        },
        methods: {
            beforeSubmit() {
                this.scrollToTop(true);
                this.preloader = true;
            },
            submit() {
                let submitData = this.escorter.selectedEscorter;
                
                if (submitData.date_of_birth != null) {
                    submitData.date_of_birth = moment(submitData.date_of_birth).format('YYYY-MM-DD');
                }

                this.submitFromFixin("patch", `escorters/${this.escorter.selectedEscorter.id}`, submitData);
            },
            afterFinalResponse() {
                this.preloader = false;
                const payload = { escorterId: this.escorter.selectedEscorter.id };
                this.$store.dispatch('getEscorter', payload);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location = urlGenerator(`app-escorters`);
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
        }
    }
</script>
